import React from 'react'
import { Trans } from '@lingui/react'
import styled from 'styled-components'

import Table from '../../util/Table'
import NewTabLinkButton from '../../util/NewTabLinkButton'
import ConfirmPopover from '../../util/ConfirmPopover'
import IconButton from '../../util/IconButton'

const toProjectLinkRow = ({
    project,
    isCurrentProject,
    level,
    projectLinkId,
}) => ({
    project,
    isCurrentProject,
    level,
    projectLinkId,
})

const ProjectLinksTable = ({
    projectLinks,
    onClickProject,
    onClickProjectNewTab,
    removeLinkEnabled = true,
    onDeleteProjectLink,
    isDeleting,
}) => (
    <Table
        data={projectLinks.map(toProjectLinkRow)}
        header={<ProjectsHeaderRow removeLinkEnabled={removeLinkEnabled} />}
        columnWidths={[20, 'auto']}
        renderRow={(projectInfo, index) => (
            <ProjectLinksTableRow
                key={index}
                onClickProject={onClickProject}
                onClickProjectNewTab={onClickProjectNewTab}
                projectInfo={projectInfo}
                removeLinkEnabled={removeLinkEnabled}
                onDeleteProjectLink={onDeleteProjectLink}
                isDeleting={isDeleting}
            />
        )}
    />
)

const ProjectsHeaderRow = ({ removeLinkEnabled, ...props }) => (
    <Table.Row>
        <Table.HeaderCell {...props}>
            <Trans id="Number" />
        </Table.HeaderCell>
        <Table.HeaderCell {...props}>
            <Trans id="Title" />
        </Table.HeaderCell>
        {removeLinkEnabled && <Table.HeaderCell {...props} />}
    </Table.Row>
)

const ProjectLinksTableRow = ({
    projectInfo,
    onClickProject,
    onClickProjectNewTab,
    onDeleteProjectLink,
    removeLinkEnabled,
    isDeleting,
}) => {
    const { project, isCurrentProject, level, projectLinkId } = projectInfo
    return (
        <StyledTableRow isCurrentProject={isCurrentProject}>
            <StyledTableCell level={level}>
                <NewTabLinkButton
                    onClick={() => onClickProject(project)}
                    onClickNewTab={() => onClickProjectNewTab(project)}
                >
                    {project.number}
                </NewTabLinkButton>
            </StyledTableCell>
            <StyledTableCell level={level}>{project.title}</StyledTableCell>
            {removeLinkEnabled && (
                <StyledTableCell textAlign="right">
                    {!isCurrentProject && (
                        <ConfirmPopover
                            hasArrow
                            isLoading={isDeleting}
                            onConfirm={() => onDeleteProjectLink(projectLinkId)}
                            confirmText={
                                <Trans id="Are you sure you want to remove this link?"  />
                            }
                        >
                            <IconButton isSmaller iconName="cross" />
                        </ConfirmPopover>
                    )}
                </StyledTableCell>
            )}
        </StyledTableRow>
    )
}

const StyledTableRow = styled(Table.Row)(
    ({ theme, isCurrentProject }) => `
    ${
        isCurrentProject &&
        `
        font-weight: ${theme.fontWeightBold};
    `
    }
`,
)
const StyledTableCell = styled(Table.Cell)(
    ({ theme, level }) => `
    padding-left: ${level * theme.spacing}rem;
`,
)

export default ProjectLinksTable
